
// import sldImg1 from "../../assets/images/home/experimentation-pioneers.svg";
// import sldImg2 from "../../assets/images/home/curiosity-as-culture.svg";
// import sldImg3 from "../../assets/images/home/data-driven-insights.svg";


import Inimg1 from "../../assets/images/home/financial.svg";
import Inimg2 from "../../assets/images/home/insurance.svg";
import Inimg3 from "../../assets/images/home/government.svg";
import Inimg4 from "../../assets/images/home/it-and-software.svg";
import Inimg5 from "../../assets/images/home/ecommerce.svg";
import Inimg6 from "../../assets/images/home/business.svg";

import img1 from "../../assets/images/home/story1.webp";
import img2 from "../../assets/images/home/story2.webp";
import img3 from "../../assets/images/home/story3.webp";
import img4 from "../../assets/images/home/story4.webp";
import productImg1 from "../../assets/images/home/lending-lab.webp";
import productImg2 from "../../assets/images/home/drive-assure.webp";
import productImg3 from "../../assets/images/home/choice-touch.webp";
import productImg4 from "../../assets/images/home/greetly.webp";
import productImg5 from "../../assets/images/home/transportation.webp";
import productImg6 from "../../assets/images/home/procurement-process.webp";
import productImg7 from "../../assets/images/home/invoicing.webp";
import productImg8 from "../../assets/images/home/empowering.webp";

import servicesIcon1 from "../../assets/images/home/android-development-icon.png";
import servicesIcon2 from "../../assets/images/home/ios-development-icon.png";
import servicesIcon3 from "../../assets/images/home/web-development-icon.png";
import servicesIcon4 from "../../assets/images/home/tech-consultation-icon.png";
import servicesIcon5 from "../../assets/images/home/data-Loss-icon.png";
import servicesIcon6 from "../../assets/images/home/data-classification-icon.png";
import servicesIcon7 from "../../assets/images/home/red-teaming-icon.png";

const HomePageData = {
    
    

    "FooterCtaSection":[
        {
            "CtaHeading": "Ready to Innovate?",
            "CtaDescriptiom":"Seize this opportunity to make your mark in the world of product innovation. Our  experts are eager to hear from you.",
            "CtaBtnText": 'Get in Touch',
            "CtaBtnLink": '/get-a-quote',
        },
    ],

    "ExperimentationSlider":[
        {
            "sliderHeading": `Powering Growth in the Loan Ecosystem: <span>Introducing Telelyzer</span>`,
            "sliderDescriptiom":"Telelyzer goes a step further than the traditional LOS and allows Banks/NBFC to innovate with sales teams,individual borrowers and business borrowers.",
            "ProductLink": "/products/telelyzer",
            "slideImg" : `${productImg1}`,
        },
        {
            "sliderHeading": `Simplifying Policy Issuance: <span>Introducing Choice Drive Assure</span>`,
            "sliderDescriptiom":"Choice Drive Assure, is an end to end digital solution for streamlining the process of motor insurance issuance.The platform is designed to make the journey",
            "ProductLink": "/products/insurance-management-system",
            "slideImg" : `${productImg2}`,
        },
        {
            "sliderHeading": "Enhance Salesforce Efficiency with Choice Touch",
            "sliderDescriptiom":"Manually managing field staff and their sales efficiency demands a significant number of man-days, making the process both costly and time-consuming.",
            "ProductLink": "/products/employee-management-system",
            "slideImg" : `${productImg3}`,
        },
        {
            "sliderHeading": `Greetly: <span>Elevating Customer Engagement</span>`,
            "sliderDescriptiom":"Greetly is a rich texture webapp designed to transform the customer experience across industries. Tailored to meet the needs of financial institutions",
            "ProductLink": "/products/customer-engagement-platform",
            "slideImg" : `${productImg4}`,
        },
        {
            "sliderHeading": "Automate your Transportation Operations with Trans-Track",
            "sliderDescriptiom":"Trans-Track is a Transport Management Software that gives businesses increased visibility over their logistics process by automating transport operations",
            "ProductLink": "/products/transport-management-system",
            "slideImg" : `${productImg5}`,
        },
        {
            "sliderHeading": `Prime: <span>Revolutionize Your Procurement Process</span>`,
            "sliderDescriptiom":"Prime Procurement, your strategic partner for transforming the purchase-to-payment journey! Say goodbye to procurement headaches with our innovative solutions",
            "ProductLink": "/products/procurement-management-software",
            "slideImg" : `${productImg6}`,
        },
        {
            "sliderHeading": `Prime: <span>Simplifying Invoicing for Every Business</span>`,
            "sliderDescriptiom":"In Prime, invoicing is a seamless process for generating and sending invoices to your clients. Prime platform offers automated workflows, and customizable",
            "ProductLink": "/products/invoice-generation-software",
            "slideImg" : `${productImg7}`,
        },
        {
            "sliderHeading": `Prime: <span>Empowering Your Employees</span>`,
            "sliderDescriptiom":"Prime for Employee benefits, a comprehensive solution to streamline travel expenses, reimbursement management, request for assets",
            "ProductLink": "/products/exployee-expenses-management-system",
            "slideImg" : `${productImg8}`,
        },
    ],


    "IndustriesSolutions":[
        {
            "slHeading": "Financial",
            "slImg" : `${Inimg1}`,
        },
        {
            "slHeading": "Insurance",
            "slImg" : `${Inimg2}`,
        },
        {
            "slHeading": "Government",
            "slImg" : `${Inimg3}`,
        },
        {
            "slHeading": "IT & Software",
            "slImg" : `${Inimg4}`,
        },
        {
            "slHeading": "Ecommerce",
            "slImg" : `${Inimg5}`,
        },
        {
            "slHeading": "Business",
            "slImg" : `${Inimg6}`,
        },
        
    ],


    "StoriesCaseStudies":[
        {
            "csHeading": "Enhancing Logistics Efficiency",
            "csDescription": "The logistics industry faces significant challenges, including complex supply chain management",
            "csImg" : `${img1}`,
            "csBtnText": 'Read More',
            "csBtnLink": '/enhance-logistics-efficiency-and-customer-satisfaction-with-choice-touch',
        },
        {
            "csHeading": "Improving Customer Engagement",
            "csDescription": "ABC Manufacturing is a leading player in the manufacturing sector, facing challenges in managing expenses effectively",
            "csImg" : `${img2}`,
            "csBtnText": 'Read More',
            "csBtnLink": '/enhancing-customer-experience-with-greetly',
        },
        {
            "csHeading": "Streamline Expenses",
            "csDescription": "ABC Insurance Co. is a leading insurance provider having a wide range of insurance products; life, health, and property insurance.",
            "csImg" : `${img3}`,
            "csBtnText": 'Read More',
            "csBtnLink": '/streamlining-expense-managment-in-manufacturing-with-prime',
        },
        
        {
            "csHeading": "Optimized SCF",
            "csDescription": "ABC FMCG Corporation, a global player in the FMCG industry, faced challenges in managing its supply chain",
            "csImg" : `${img4}`,
            "csBtnText": 'Read More',
            "csBtnLink": '/enhancing-supply-chain-efficiency-with-prime',
        },
        
    ],
    "OurSarvices":[
        {
            "sHeading": "Android Development",
            "sDescription": "Our Android Development service offers comprehensive solutions to bring your mobile application ideas to life.",
            "sImg" : `${servicesIcon1}`,
            "sBtnText": 'Read More',
            "sBtnLink": '/services/android-app-development',
        },
        {
            "sHeading": "iOS Development",
            "sDescription": "Our iOS Development service is designed to create high-performance, secure, and visually stunning applications for Apple devices.",
            "sImg" : `${servicesIcon2}`,
            "sBtnText": 'Read More',
            "sBtnLink": '/services/ios-app-development',
        },
        {
            "sHeading": "Web Development",
            "sDescription": "Our Web Development service is your gateway to creating powerful online experiences that resonate with your audience.",
            "sImg" : `${servicesIcon3}`,
            "sBtnText": 'Read More',
            "sBtnLink": '/services/web-development-services',
        },
        
        {
            "sHeading": "Tech Consultation",
            "sDescription": "Our Tech Consultation service is your strategic partner in navigating the ever-evolving landscape of technology.",
            "sImg" : `${servicesIcon4}`,
            "sBtnText": 'Read More',
            "sBtnLink": '/services/tech-consulting-services',
        },
        {
            "sHeading": "Data Loss Prevention",
            "sDescription": "Our Data Loss Prevention (DLP) service empowers organizations to safeguard their sensitive data and prevent unauthorized access or leaks",
            "sImg" : `${servicesIcon5}`,
            "sBtnText": 'Read More',
            "sBtnLink": '/services/data-loss-protection',
        },
        {
            "sHeading": "Data Classification",
            "sDescription": "Our Data Classification Platform empowers organizations to organize, manage, and protect their data assets effectively.",
            "sImg" : `${servicesIcon6}`,
            "sBtnText": 'Read More',
            "sBtnLink": '/services/data-classification-platform',
        },
        
        {
            "sHeading": "Red Teaming",
            "sDescription": "Our Red Teaming service goes beyond traditional penetration testing to simulate real-world cyber attacks and assess your organization's security posture comprehensively",
            "sImg" : `${servicesIcon7}`,
            "sBtnText": 'Read More',
            "sBtnLink": '/services/red-teaming-services',
        },
        
    ],
    "OurProducts":[
        {
            "pHeading": "Prime: Procurement",
            "pDescription": "Prime Procurement, your strategic partner for transforming the purchase-to-payment journey.",
            "pBtnText": 'Read More',
            "pBtnLink": '/products/procurement-management-software',
        },
        {
            "pHeading": "Prime: Cash Flow Management",
            "pDescription": "In Prime, invoicing is a seamless process for generating and sending invoices to your clients.",
            "pBtnText": 'Read More',
            "pBtnLink": '/products/invoice-generation-software',
        },
        {
            "pHeading": "Prime: Employee Benefits",
            "pDescription": "Prime for Employee benefits, a comprehensive solution to streamline travel expenses.",
            "pBtnText": 'Read More',
            "pBtnLink": '/products/exployee-expenses-management-system',
        },
        {
            "pHeading": "Choice Touch",
            "pDescription": "Manually managing field staff and their sales efficiency demands a significant number of man-days.",
            "pBtnText": 'Read More',
            "pBtnLink": '/products/employee-management-system',
        },
        {
            "pHeading": "Greetly",
            "pDescription": "Greetly is a rich texture webapp designed to transform the customer experience.",
            "pBtnText": 'Read More',
            "pBtnLink": '/products/customer-engagement-platform',
        },
        {
            "pHeading": "Drive Assure",
            "pDescription": "Choice Drive Assure, is an end to end digital solution for streamlining  the process of motor insurance.",
            "pBtnText": 'Read More',
            "pBtnLink": '/products/insurance-management-system',
        },
        {
            "pHeading": "Trans-Track",
            "pDescription": "Trans-Track is a Transport Management Software that gives businesses increased.",
            "pBtnText": 'Read More',
            "pBtnLink": '/products/transport-management-system',
        },
        // {
        //     "pHeading": "Telelyzer",
        //     "pDescription": "Telelyzer is an advanced AI tool that revolutionizes customer call analysis for organizations.",
        //     "pBtnText": 'Read More',
        //     "pBtnLink": '/products/telelyzer',
        // },
       
    ],
    
} 

export default HomePageData